function SettingsPromotersCtrl($scope, $state, organizationRelationshipService, organizationService, alertService, sdkUtils, modalService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  _getOrganizationRelationships();

  function _initScope() {
    $scope.loading = true;

    /**
     * @desc Form for the Relationship search box
     */
    $scope.relationshipFilterForm = {
      searchTerm: null
    };

    /**
     * @desc jQuery Data Table options
     */
    $scope.relationshipListDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50
    };

    $scope.linkCopied = function(relationship, $event) {
      if ($event) $event.preventDefault();

      relationship.showCopiedTooltip = true;
    };
    $scope.getAttribution = function(relationship) {
      return `attributionId=${relationship.id}&attributionType=RELATIONSHIP`;
    };

    $scope.relationshipDataTableInstance = {};

    /**
     * @desc on-keyup handler for the Relationship search box
     */
    $scope.filterRelationshipList = function filterRelationshipList() {
      if ($scope.relationshipDataTableInstance && $scope.relationshipDataTableInstance.DataTable) {
        $scope.relationshipDataTableInstance.DataTable.search($scope.relationshipFilterForm.searchTerm).draw();
      }
    };

    $scope.deleteRelationship = _deleteRelationship;

    watchVenueChange();
  }

  /**
   * @return {Promise}
   */
  function _getOrganizationRelationships() {
    const options = {};

    if ($scope.selectedVenue) options.venueId = $scope.selectedVenue.id;

    $scope.loading = true;

    return organizationRelationshipService.listByOrganizationId(currentUserOrganization.id, options)
      .then(relationships => {
        $scope.relationships = relationships;
      })
      .catch(response => {
        alertService.fatalError(response);
      })
      .finally(() => {
        $scope.loading = false;
      });
  }

  function _deleteRelationship(relationship, $event) {
    if (!relationship) return;
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: `Delete External Member ${relationship.name}`,
        modalMessage: 'Are you sure you want to delete this external member?',
        confirmBtnTxt: 'Delete External Member',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          organizationRelationshipService.deleteByIdAndOrganizationId(relationship.id, currentUserOrganization.id)
            .then(() => {
              const index = $scope.relationships.indexOf(relationship);

              $scope.relationships.splice(index, 1);

              alertService.success('External Member deleted');
            })
            .catch(response => {
              alertService.error(sdkUtils.getErrorFromResponse(response));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function watchVenueChange() {
    $scope.$watch('selectedVenue', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        _getOrganizationRelationships();
      }
    });
  }
}

SettingsPromotersCtrl.$inject = [
  '$scope',
  '$state',
  'jsSdk.organizationRelationship',
  'organizationService',
  'alertService',
  'jsSdk.utils',
  'modalService'
];

export default SettingsPromotersCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsPromoters/settingsPromotersCtrl.js